import { CircleAlert } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Report from '@/assets/smartcity/report-icon.svg';
import Button from '@/shared/components/ui/Button';

interface ModalRegisterProps {
  isOpen?: boolean;
  onClose?: () => void;
  onRegister?: () => void;
  onEdit?: () => void;
  timesTamp: string;
  logData?: Record<string, any>;
  typeModal?: 'regis' | 'close';
}

const ModalRegister = ({
  isOpen,
  onClose,
  onRegister,
  onEdit,
  logData,
  timesTamp,
  typeModal = 'regis',
}: ModalRegisterProps) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[1000]">
      <div className="w-[30%] p-6 flex flex-col gap-3  bg-db-card border bg-db-border  rounded-[5px] overflow-hidden">
        <div className="w-full flex flex-row gap-3 items-center">
          <img src={Report} alt="reject icon" />
          <div className="flex flex-col">
            <span className="h5bold capitalize ">
              {typeModal === 'regis' ? t('psc>modal>register report') : t('psc>modal>close report')}
            </span>
            <span className="title2 text-db-text-grey ">
              {typeModal === 'regis'
                ? t('psc>modal>register report detail')
                : t('psc>modal>close report detail')}
            </span>
          </div>
        </div>

        {typeModal === 'regis' && (
          <div className="w-full inline-flex gap-3 justify-between items-center bg-[#F3F6FE] p-3 rounded-[4px] ">
            <span className="title1 text-text-grey">{t('cmn>master>timestamp')}</span>
            <span className="title1 text-black">{timesTamp}</span>
          </div>
        )}

        <div className="w-full inline-flex gap-3  items-center bg-text-danger-300 p-3 rounded-[4px] ">
          <CircleAlert color="#ed3131" />
          <span className="title1 text-text-grey italic">
            {t('psc>modal>status cannot change')}
          </span>
        </div>

        <div className="w-full flex justify-center pb-2 items-center m-auto gap-3">
          {typeModal === 'regis' ? (
            <>
              <Button
                bg-text-danger-300
                className="flex-1 btn-fill-red-ghost text-[20px]  cursor-pointer"
                label={t('cmn>master>cancel')}
                onClick={onClose}
              />
              <Button
                bg-text-danger-300
                className="flex-1 btn-fill-blue text-[20px] cursor-pointer "
                label={t('psc>modal>continue register')}
                onClick={onRegister}
              />
            </>
          ) : (
            <>
              <Button
                bg-text-danger-300
                className="flex-1 btn-outline-blue  text-[20px]  cursor-pointer"
                label={t('psc>modal>keep editing')}
                onClick={onEdit}
              />
              <Button
                bg-text-danger-300
                className="flex-1 btn-fill-blue text-[20px] cursor-pointer "
                label={t('psc>modal>close report button')}
                onClick={onClose}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalRegister;
